import type { EventEmitter } from '@angular/core';
import type { SingleFieldExplanationContent } from '@legacy/common-ui-utility-components';
import type { InnogyComponentRendering } from '@core/jss-models';
import type { StepViewModel } from '@innogy/shared/forms';

import type { SingleFieldQuestionContent } from '../interfaces';
import type { ProgressiveFormService } from '../progressive-form.service';
import { translateRadioOption } from './button-options/button-options.helper';

export class ProgressiveFormStepBaseComponent {
  progressiveFormSelectorKey!: string;
  rendering: InnogyComponentRendering | undefined;
  content!: SingleFieldQuestionContent;
  formStep?: StepViewModel;
  giveMoreInfo?: EventEmitter<SingleFieldExplanationContent>;
  stepNumber?: number;

  translateRadioOption = translateRadioOption;

  get submitButtonAutomationId() {
    return this.formStep?.stepId + '-next-button';
  }

  constructor(
    protected readonly progressiveFormService: ProgressiveFormService
  ) {}

  get currentStepIndex$() {
    return this.progressiveFormService.currentStepPresentableNumber$(
      this.progressiveFormSelectorKey,
      this.formStep?.stepId
    );
  }
}
